export const createAction = (type, data) => {
  return { type: type, payload: data };
};
